import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import auth from "./auth";
import appControllers from "./appControllers";
import users from "./users";
import messages from "./messages";
import notifications from "./notifications";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import { reducer as formReducer } from "redux-form";

const rootReducer = combineReducers({
  auth,
  users,
  notifications,
  messages,
  appControllers,
  form: formReducer
});

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["auth", "appControllers"]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

function configureStore() {
  // Enhancers for developpement purpose
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  // The store
  const store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(thunk))
  );
  return store;
}

let store = configureStore();
let persistor = persistStore(store);

export default {
  store,
  persistor
};
